import {API} from '../../api/API';
import {extractError} from '../../api/ErrorUtil';
import { USER_REGISTRATION_URL } from '../../config/config';


export const saveUserRegistration = (user,userRegistrationSuccessHandler,userRegistrationFailureHandler) => {
    console.log("Entering saveUserRegistration");
    API.post(USER_REGISTRATION_URL, user)
    .then(res => {
        userRegistrationSuccessHandler(res.data)
    })
    .catch(err => {
        let errors = extractError(err);
        userRegistrationFailureHandler(errors);
    });
}